var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from "react";
import styled from "styled-components";
import DataCatalogTable from "../components/data-catalog/DataCatalogTable";
var Container = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  padding: 1rem;\n"], ["\n  padding: 1rem;\n"])));
var PollinatorPage = function () {
    return (React.createElement(Container, null,
        React.createElement(DataCatalogTable, { title: "Pollinator Checks" })));
};
export default PollinatorPage;
var templateObject_1;
